<script setup>
import "@/styles/css/calculator-base.scss";
import "@/styles/css/seo-calculators.scss";
import { ref } from "vue";
const view = ref(false);
</script>
<template>
  <main class="upstox-calculators mt-[64px]" id="npv-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>NPV Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->

    <section class="calculator-background"></section>

    <section class="calculator">
      <div class="container">
        <h1 class="title">NPV Calculator</h1>
        <div class="cal-structure npv-cal">
          <div class="inner-row cal-slider" id="cal-slider">
            <div class="input-section calc-slide">
              <div class="calc-slide-inner">
                <div class="form-group investment-main">
                  <label for="investment">
                    <h3 id="investment-title">Initial Investment</h3>
                  </label>
                  <input
                    type="text"
                    id="investment"
                    value="₹ 100000"
                    class="input"
                    data-type="rupee"
                  />
                </div>
                <div class="form-group group-merge-top">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="discount-title">Discount Rate</h3>
                    </label>
                    <input
                      type="text"
                      value="12%"
                      min="1"
                      max="40"
                      id="return-rate-input"
                      class="input"
                      data-type="percent"
                    />
                  </div>
                  <input
                    type="range"
                    value="12"
                    step="0.1"
                    min="1"
                    max="20"
                    id="return-rate-slider"
                    class="slider-range"
                  />
                </div>

                <div class="form-group">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="years-title">No.of Years</h3>
                    </label>
                    <input
                      type="text"
                      value="5 years"
                      min="1"
                      max="30"
                      id="period-input"
                      class="input"
                      data-type="years"
                    />
                  </div>
                  <input
                    type="range"
                    value="5"
                    step="1"
                    min="1"
                    max="30"
                    id="period-input-slider"
                    class="slider-range"
                  />
                </div>

                <div class="form-group inflows-group">
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="cash-flow-nature-title">
                        Nature of Cash Inflows
                      </h3>
                    </label>
                  </div>
                  <select class="inflows-cash" id="nature-of-cash-inflows">
                    <option value="fixed">Yearly Fixed Cash Inflows</option>
                    <option value="variable">
                      Yearly variable Cash Inflows
                    </option>
                  </select>
                </div>

                <div
                  class="form-group cash-inflow-input cash-inflow-input"
                  id="fixed"
                  style="display: block"
                >
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="amount-title">
                        Amount of Fixed Cash Inflows P.A
                      </h3>
                    </label>
                    <input
                      type="text"
                      value="₹ 10000"
                      min="10"
                      max="2000000"
                      id="fixed-cash-inflow"
                      class="input"
                      data-type="rupee"
                    />
                  </div>
                  <input
                    type="range"
                    value="10000"
                    min="10"
                    max="2000000"
                    step="10"
                    id="fixed-cash-inflow-slider"
                    class="slider-range"
                  />
                </div>

                <div
                  class="form-group cash-flow cash-inflow-input"
                  id="variable"
                >
                  <div class="group-merge-main">
                    <label for="investment">
                      <h3 id="investment-title">Cash Flow</h3>
                    </label>
                  </div>
                  <div
                    class="group-year-merge section-npv-yearvar"
                    id="npv-yearvar"
                  >
                    <div class="group-year-sub year-1">
                      <label class="year-sub">Year 1</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-2">
                      <label class="year-sub">Year 2</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-3">
                      <label class="year-sub">Year 3</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-4">
                      <label class="year-sub">Year 4</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-5">
                      <label class="year-sub">Year 5</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-6">
                      <label class="year-sub">Year 6</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-7">
                      <label class="year-sub">Year 7</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-8">
                      <label class="year-sub">Year 8</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-9">
                      <label class="year-sub">Year 9</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-10">
                      <label class="year-sub">Year 10</label>
                      <input
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                    <div class="group-year-sub year-11">
                      <label class="year-sub">Year 11</label>
                      <input
                        id="ten-plus-year"
                        type="text"
                        class="input"
                        value="₹ 0"
                        data-type="rupee"
                      />
                    </div>
                  </div>
                </div>

                <div class="mob-calc-btn">
                  <button id="calculate" class="calc-btn-mob">Calculate</button>
                </div>
              </div>
            </div>
            <div class="output-section calc-slide cal-loader">
              <div class="calc-slide-inner">
                <lottie-player
                  src="/json-data/lottie/calculator-loader.json"
                  background="transparent"
                  speed="1"
                  loop=""
                  autoplay=""
                ></lottie-player>
              </div>
            </div>
            <div class="output-section calc-slide">
              <div class="calc-slide-inner">
                <div class="mob-results">
                  <h5>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/back-arrow.svg"
                      alt=""
                      id="back-button"
                    />
                    Your results
                  </h5>
                </div>
                <h3>Total value of your investment:</h3>
                <div class="distribution-bar background-color-bar">
                  <div class="grey investment" style="width: 9900%"></div>
                  <div class="green returns" style="width: 100%"></div>
                </div>
                <div class="invest-list">
                  <ul>
                    <li>
                      <span class="grey-circle"></span>
                      <h5>Present Value</h5>
                    </li>
                    <li>
                      <span class="green-circle"></span>
                      <h5>Future Value</h5>
                    </li>
                  </ul>
                </div>

                <div class="row outer-listing-group">
                  <div class="outer-grp">
                    <h4>Present Value Of Cash Inflows (PVIFA)</h4>
                    <span id="invested-amount">₹ 36,048</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Net Present Value (NPV)</h4>
                    <span id="total-investment">₹ -63,952</span>
                  </div>
                  <div class="bottom-text">
                    <p>
                      <span class="capital-text">ZERO</span> annual maintenance
                      charges only for new users for the
                      <strong>next 10 days</strong>
                    </p>
                    <a
                      href="https://wa.me/+917092362098"
                      class="get-start-btn"
                      >Get Started Today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--------------last 3 calculations -------------------->

    <section class="last-three-calculations">
      <div class="container last-three-cal-mobile">
        <h3>Last 3 calculations</h3>
        <p>Your calculations are erased upon refreshing!</p>
        <div class="calc-inner" id="cal-history"></div>
      </div>
    </section>

    <!--------------------Start Key Indicies Template--------------------------->

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in NSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/nifty-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 50"
                    />
                  </div>
                  <div class="key-content">NIFTY 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-next-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Next 50"
                    />
                  </div>
                  <div class="key-content">NIFTY NEXT 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-bank-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Bank"
                    />
                  </div>
                  <div class="key-content">NIFTY BANK</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 100"
                    />
                  </div>
                  <div class="key-content">NIFTY 100</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 200"
                    />
                  </div>
                  <div class="key-content">NIFTY 200</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 500"
                    />
                  </div>
                  <div class="key-content">NIFTY 500</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-midcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Midcap 50"
                    />
                  </div>
                  <div class="key-content">NIFTY MIDCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-smlcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="NIFTY SMLCAP 50"
                    />
                  </div>
                  <div class="key-content">NIFTY SMLCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/india-vix-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="India VIX"
                    />
                  </div>
                  <div class="key-content">INDIA VIX</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in BSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/sensex-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SENSEX"
                    />
                  </div>
                  <div class="key-content">SENSEX</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE100"
                    />
                  </div>
                  <div class="key-content">BSE100</div>
                </a>
              </li>
              <li>
                <a href="/indices/lrgcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="LRGCAP"
                    />
                  </div>
                  <div class="key-content">LRGCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/midcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="MIDCAP"
                    />
                  </div>
                  <div class="key-content">MIDCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/smlcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMLCAP"
                    />
                  </div>
                  <div class="key-content">SMLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE500"
                    />
                  </div>
                  <div class="key-content">BSE500</div>
                </a>
              </li>
              <li>
                <a href="/indices/allcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="ALLCAP"
                    />
                  </div>
                  <div class="key-content">ALLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE200"
                    />
                  </div>
                  <div class="key-content">BSE200</div>
                </a>
              </li>
              <li>
                <a href="/indices/bseipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSEIPO"
                    />
                  </div>
                  <div class="key-content">BSEIPO</div>
                </a>
              </li>
              <li>
                <a href="/indices/smeipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMEIPO"
                    />
                  </div>
                  <div class="key-content">SMEIPO</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--------------------END Key Indicies Template--------------------------->

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is net present value (NPV)?</h2>
      <p></p>
      <p>
        NPV or the net present value shows the difference between the present
        value of future cash flows and the current investment. We derive the
        present value of expected cash flows by discounting them at a specified
        rate of return. NPV is a widely used cash-budgeting method for assessing
        projects and investments.
      </p>
      <p>
        To understand this term better, you first need to understand the term
        present value. For example, imagine that you want to have ₹25,000 in
        your account next year and the yearly interest rate on that account is
        10%. This means that you need to deposit ₹22,500 in that account today
        to have ₹25,000 twelve months from now. The present value of ₹25,000 due
        in 12 months is ₹22,500.
      </p>
      <p>
        Also note that for a positive discount rate, the future value (FV) is
        always higher than the present value (PV).
      </p>
      <p></p>
    </section>
    <!-- Calculator Faqs Section-->

    <section class="faqs" id="faqs">
      <div class="container">
        <div class="faq-card nav-list" id="faq">
          <div class="faq-card-details stock-card-header">
            <div class="faq-card-desc">
              <h2 class="heading">Frequently Asked Questions</h2>
            </div>
          </div>
          <div class="stock-card-content dynamic-faq">
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-1">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-1"
                  >
                    <span class="flex-grow">What is an NPV calculator?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is an NPV calculator?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-1" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    An NPV calculator estimates the current value of an
                    investment. Using the calculator, you can calculate the
                    value of an investment or project based on expenses,
                    revenue, and capital costs. You can use it to determine if
                    the project is worth investing in. You need to enter the
                    investment amount, discount rate, and number of years into
                    the formula box of the NPV calculator. The calculator shows
                    you the present value of inflows and net current value based
                    on the type of inflows you select.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-2">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-2"
                  >
                    <span class="flex-grow"
                      >How is NPV different from IRR?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How is NPV different from IRR?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-2" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    NPV is the difference between the present value of future
                    cash inflows and the present value of cash outflows. On the
                    other hand, the internal rate of return (IRR) is the rate at
                    which the net present value of cash inflows is equal to the
                    net present value of cash outflows.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-3">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-3"
                  >
                    <span class="flex-grow"
                      >What are the expected cash flows?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What are the expected cash flows?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-3" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The Upstox NPV calculator determines two values as results.
                    The first one is NPV, and the second is called the “expected
                    cash flows”. This is the present value of all of your cash
                    inflows but does not take the initial investment into
                    account.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-4">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-4"
                  >
                    <span class="flex-grow"
                      >What are the benefits of using Upstox NPV
                      calculator?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What are the benefits of using Upstox NPV calculator?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-4" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The NPV calculator helps to determine the net present value
                    of cash inflows and the net present value of an investment
                    or project. The calculator provides precise results.
                    However, it is important to note that an investment’s net
                    present value is just an estimation. Also, the NPV
                    calculator does not guarantee returns. Therefore, one should
                    only use the calculator to estimate the net present value of
                    their cash inflows.
                  </p>
                  <p class="visible">
                    By calculating the net present value of cash inflows from a
                    project or investment, one can better plan investments and
                    achieve financial objectives. Investing in items that earn
                    inflation-beating returns can be calculated by determining
                    the opportunity cost of an investment. Therefore, one can
                    use the calculator to estimate the net present value of an
                    investment option across multiple scenarios.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-5">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-5"
                  >
                    <span class="flex-grow"
                      >How do you calculate NPV using a calculator?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How do you calculate NPV using a calculator?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-5" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    It’s simple to use the NPV calculator. You need to enter the
                    variables, and the calculator quickly calculates the final
                    answer.
                  </p>
                  <p class="visible">
                    The formula to calculate NPV is given as follows:
                  </p>
                  <p class="visible">NPV = ∑(P/ (1+i)t ) – C</p>
                  <p class="visible">
                    Where P = net period cash flow<br />
                    i = discount rate (rate of return)<br />
                    t = number of time period<br />
                    C = initial investment
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-6">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-6"
                  >
                    <span class="flex-grow"
                      >What is the formula for the present value of an
                      annuity?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is the formula for the present value of an annuity?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-6" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    The formula used to calculate the PV of an annuity is as
                    follows:
                  </p>
                  <p class="visible">
                    P = PMT x ((1 – (1 / (1 + r) ^ -n)) / r)
                  </p>
                  <p class="visible">
                    where P = the current value of the annuity<br />
                    PMT = the installment amount paid for annuity<br />
                    R= the rate of interest or discount rate<br />
                    n = the number of installments left to receive
                  </p>
                  <p class="visible">
                    It can be tricky to calculate the PV of an annuity using the
                    above formula. But our online present value of an annuity
                    calculator will calculate the final amount in seconds.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-7">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-7"
                  >
                    <span class="flex-grow"
                      >How do you calculate the discount rate for NPV?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How do you calculate the discount rate for NPV?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-7" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    To determine the discount rate for future cash flow, you
                    must know the NPV of your asset or investment. in the
                    following formula you can solve for ‘r’ if you know the NPV:
                  </p>
                  <p class="visible">
                    P = PMT x ((1 – (1 / (1 + r) ^ -n)) / r)
                  </p>
                  <p class="visible">
                    Determining the discount rate is a critical concept in
                    finance used by investors to decide the future value of an
                    investment in your business. You can solve for a discount
                    rate by using a present value calculator.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-8">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-8"
                  >
                    <span class="flex-grow"
                      >Is a higher or lower NPV better?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Is a higher or lower NPV better?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-8" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    NPV is a critical metric that calculates the present value
                    of your future investments based on cash inflows and
                    outflows. You get a good return when the cash inflow exceeds
                    the cash outlay. When NPV is zero, there is no change in
                    investment. Similarly, a positive difference between inflow
                    and outflow indicates that you are making more money than
                    you are spending. In theory, you should invest when the NPV
                    is positive.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-9">
                <h3 class="panel-title">
                  <span
                    class="panel-trigger"
                    data-toggle="collapse"
                    data-parent="#faqs"
                    href="#collapse-9"
                  >
                    <span class="flex-grow">What is a good NPV?</span>
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="What is a good NPV?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-9" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    A positive NPV number indicates that the investment is
                    viable. The higher the positive NPV value, the better your
                    future return on investment. An NPV of zero denotes that
                    cash inflow equals cash outflow, while a negative NPV
                    denotes a loss. NPV is the gold standard in financial
                    decision-making. Using a NPV calculator, you can quickly
                    assess the viability of your investment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button
            class="similar-btn btn-all"
            v-if="!view"
            @click="view = !view"
          >
            View all
          </button>
          <button
            class="similar-btn btn-less"
            v-if="view"
            @click="view = !view"
          >
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="[view ? 'smooth-wrap2' : '']">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> PPF Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
